const DEFAULT_CREDENTIALS = 'same-origin';

export function createRequest(
  input: RequestInfo | URL,
  init?: RequestInit
): Request {
  if (input instanceof Request) return new Request(input, init);
  if (input instanceof URL) input = input.toString();

  return new Request(input, { credentials: DEFAULT_CREDENTIALS, ...init });
}
